import React from 'react';

const Card = ({ children }) => (
  <div className="card" style={{ height: '100%' }}>
    { children }
  </div>
);

export default Card;
